export default function (err, dispatch) {
  switch (err.message) {
    case  'データ初期化はAdminユーザーのみが実行できます。':
      dispatch('toast/show', {
        title: '実行失敗',
        content: 'データ初期化はAdminユーザーのみが実行できます。',
        variant: 'danger'
      }, { root: true })
      break

    case  'email: This value is not a valid email address.':
      dispatch('toast/show', {
        title: '登録失敗',
        content: '不正なメールアドレスの形式です。',
        variant: 'danger'
      }, { root: true })
      break

    case 'Invalid user credentials':
      dispatch('toast/show', {
        title: 'ログイン失敗',
        content: 'メールアドレスかパスワードが間違っています。',
        variant: 'danger'
      }, { root: true })
      break

    case 'Cannot delete the last admin user. There should always be at least 1 active admin user':
      dispatch('toast/show', {
        title: '削除失敗',
        content: '管理者ユーザーは最低1人は必要です。',
        variant: 'danger'
      }, { root: true })
      break

    case 'Unauthorized request':
      window.location.pathname = '/'
      break

    default:
      console.log(err, err.message)
  }
}
